import React from 'react';
import PropTypes from 'prop-types';

const PowerOffIcon = () => {
  return (
    <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="power-off" className="svg-inline--fa" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path fill="currentColor" d="M388.5 46.3C457.9 90.3 504 167.8 504 256c0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 168 54 90.3 123.5 46.3c5.8-3.7 13.5-1.8 16.9 4.2l11.8 20.9c3.1 5.5 1.4 12.5-3.9 15.9C92.8 122.9 56 185.1 56 256c0 110.5 89.5 200 200 200s200-89.5 200-200c0-70.9-36.8-133.1-92.3-168.6-5.3-3.4-7-10.4-3.9-15.9l11.8-20.9c3.3-6.1 11.1-7.9 16.9-4.3zM280 276V12c0-6.6-5.4-12-12-12h-24c-6.6 0-12 5.4-12 12v264c0 6.6 5.4 12 12 12h24c6.6 0 12-5.4 12-12z">
      </path>
    </svg>
  );
};

PowerOffIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default PowerOffIcon;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/components/Header/components/PowerOffIcon/index.js
 **/